import { ref } from "@vue/composition-api";
import {
  AiResponseMode,
  AiUserSettings,
  InputAiUserSettingsUpdate,
} from "@scrile/api-provider/dist/api/AiSettingsProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export const useAiUserSettings = () => {
  const { authUser, authorities } = useAuthUser();
  const aiAllowed = ref(false);
  const aiResponseEnabled = ref(false);
  const aiMode = ref(AiResponseMode.SUGGESTION);

  const setAiUserSettings = (settings: AiUserSettings) => {
    aiAllowed.value = settings.allowed;
    aiResponseEnabled.value = settings.responseEnabled;
    aiMode.value = settings.responseMode;
  };

  const getAiUserSettings = async () => {
    if (!authUser.value || !checkAuthorities(authorities.value, ["getMyAiUserSettings"])) return;
    const response = await providers.AiSettingsProvider.userSettingsSearch({ userId: authUser.value.id });
    setAiUserSettings(response);
  };

  const updateAiUserSettings = async ({ aiResponseEnabled = false }: { aiResponseEnabled: boolean }) => {
    if (!authUser.value || !checkAuthorities(authorities.value, ["getMyAiUserSettings"])) return;
    const data: InputAiUserSettingsUpdate = {
      userId: authUser.value.id,
      responseEnabled: aiResponseEnabled,
    };
    const resp = await providers.AiSettingsProvider.userSettingsUpdate({ data });
    setAiUserSettings(resp);
  };

  return {
    aiMode,
    aiAllowed,
    aiResponseEnabled,
    getAiUserSettings,
    updateAiUserSettings,
  };
};
